export const checkOverflow = (ref: any) => {
  const el: any = ref.current;
  const curOverflow = el.style.overflow;
  if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";
  //marginbottom of 6 px
  const isOverflowing = el.clientHeight + 1 < el.scrollHeight;
  el.style.overflow = curOverflow;
  return isOverflowing;
};
